import isEqual from 'lodash/isEqual';

import { traverse } from '@atlaskit/adf-utils/traverse/main';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

const TOC_RELEVANT_EXTENSION_KEYS = new Set(['excerpt-include', 'include-page', 'include']);

type CheckIsEqualOptions = {
	includeSyncBlocks?: boolean;
};

const collectTocRelevantNodes = (
	adf: ADFEntity | undefined,
	{ includeSyncBlocks = false }: CheckIsEqualOptions = {},
): ADFEntity[] => {
	const nodes: ADFEntity[] = [];

	if (!adf) {
		return nodes;
	}

	traverse(adf, {
		heading: (node) => {
			nodes.push(node);
		},
		extension: (node) => {
			if (TOC_RELEVANT_EXTENSION_KEYS.has(node?.attrs?.extensionKey)) {
				nodes.push(node);
			}
		},
		bodiedExtension: (node) => {
			if (TOC_RELEVANT_EXTENSION_KEYS.has(node?.attrs?.extensionKey)) {
				nodes.push(node);
			}
		},
		syncBlock: (node) => {
			const localId = node?.attrs?.localId;
			const resourceId = node?.attrs?.resourceId;
			if (includeSyncBlocks && typeof localId === 'string' && typeof resourceId === 'string') {
				// These fields fully describe a reference synced block for TOC
				// purposes: localId is the content-map key and heading-id prefix,
				// while resourceId selects the subscribed source content.
				nodes.push({ type: 'syncBlock', attrs: { localId, resourceId } });
			}
		},
	});

	return nodes;
};

export const checkIsEqual = (
	prevADF: ADFEntity | undefined,
	nextADF: ADFEntity | undefined,
	options?: CheckIsEqualOptions,
): boolean => {
	return isEqual(
		collectTocRelevantNodes(prevADF, options),
		collectTocRelevantNodes(nextADF, options),
	);
};
